var styleDataHash = "719d6c4d";
const injectCss = () => {
  var css = `.Pj8mX{color:#116dff;text-decoration:underline}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var insert_decoration_modal_default = {
  "spacingSelector": "Pj8mX"
};
export {
  insert_decoration_modal_default as default,
  injectCss
};
//# sourceMappingURL=insert-decoration-modal-scss.js.map
